<template>
<div class="page">
    <div class="top-holder">
        <img src="https://cdn.xjy0.cn/ticket/trace/trace_fail.png" alt="">
        <div>该地区暂不支持追溯！</div>
    </div>
    <div class="tip">
        <div>若需此服务，请联系新疆七色花信息科技有限公司</div>
        <div>联系人：陶涛;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;联系电话：<span class="mobile">13999309920</span> </div>
    </div>
    <div class="gradient"><a href="tel:13999309920" style="color:#fff;">立即咨询</a></div>


</div>
</template>

<script>
export default {
    data() {
        return {

        };
    },

    mounted() {
        this.hideTabbar();
    },
    beforeDestroy() {
        this.showTabbar();
    },
    methods: {
        call() {

        }
    },
};
</script>

<style lang="less" scoped>
.page {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: '微软雅黑';
    font-size: @font-28px;
    color: @lightgray;
    overflow: hidden;
    .top-holder {
        margin-top: 200px;
        img {
            width: 70%;
        }
        div {
            margin: 30px 0 90px;
            font-size: @font-32px;
            color: #333;
        }
    }
    .tip {
        margin-bottom: 120px;
    }
    .mobile {
        color: #f59126;
    }
    .gradient {
        width: 85%;
        height: 80px;
        border-radius: 50px;
        background-image: linear-gradient(to right, #20c854, #7edf39);
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: @font-32px;
    }
}
.van-button {
    height: 90px;
    font-size: @font-34px; 
}
</style>
